// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"391":"info","501":"administration","887":"user-panel"}[chunkId] || chunkId) + "." + {"252":"88df49e7","265":"0f89b961","391":"edf88c2c","501":"977625e4","887":"d06267c1"}[chunkId] + ".chunk.js";
};